import { NgModule } from '@angular/core';
import { CalendarComponent } from './calendar/calendar.component';

@NgModule({
  declarations: [CalendarComponent],
  imports: [
  ],
  exports: [CalendarComponent]
})
export class FullCalendarModule { }
